import React from "react";
import GenericLayout from "layouts/generic";
import StripesSvg from "/public/images/misc/stripesFull.svg";
import ImageCard from "@/components/imageCard";
import css from "./index.module.scss";
import Head from "next/head";
import { trimTeaser } from "scripts/utils";

export default function ResourcesLayout({
  articles,
  title,
  description,
  headline,
  canonical = null,
  subheadline}) {
  if (!articles.length || articles.length === 0){
    return <div>Not Available - api.deviatelabs.com down</div>;
  }

  return <GenericLayout title={title} description={description} canonical={canonical}>
    <Head>
      <link rel="alternate" type="application/rss+xml" href="https://deviatelabs.com/api/rss"/>
    </Head>
    <section className={`section ${css.articles}`}>
      <div className={css.background}>
        <StripesSvg/>
      </div>
      <div className={`sectionInner ${css.sectionInner}`}>
        <h2>{headline}</h2>
        <div className={css.subheadline}>{subheadline}</div>
        <div className={css.articles}>
          {(articles || [])
            .sort((a, b) => {
              if (a.attributes.priority === b.attributes.priority){
                return (new Date(b.attributes.publishedAt)).getTime() - (new Date(a.attributes.publishedAt)).getTime();
              }
              return b.attributes.priority - a.attributes.priority;
            })

            .map((article, idx) => <ImageCard
              key={article.id}
              headline={article.attributes.headline}
              href={`/resources/${article.attributes.slug}`}
              image={article?.attributes?.coverArt?.data?.attributes}
              jumbo={idx === 0}
              imageSizes={idx === 0 ? "100vw" : "(max-width:800px) 100vw, 700px"}
              loading={idx <= 3 ? "eager" : "lazy"}
            >
              <div className={css.articleTeaser}>{trimTeaser(article.attributes.teaser, idx)}</div>
            </ImageCard>)}
        </div>

      </div>
    </section>

  </GenericLayout>;
}
